import { render, staticRenderFns } from "./HelpAdministradorUnidade.vue?vue&type=template&id=ba9c8446"
import script from "./HelpAdministradorUnidade.vue?vue&type=script&lang=js"
export * from "./HelpAdministradorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports